import { PointType } from './types'

import { path } from 'd3-path'

const colors = {
    defaultGroundColor: '#d2c199',

    bgGroundColor: 'rgb(230, 207, 161)',

    lightGrey: '#f9f9f9',

    linesGrey: '#ddd',

    airColor: 'rgb(200, 233, 250)',

    waterColor: '#374159',

    textGrey: '#868695',

    darkGrey: '#414042',

    indicatorPath: '#cfd8ec',

    indicatorCircle: '#b7a5b3',

    whiteForDarkMode: '#f2f7ff',

    sideChartGreen: '#01C292',

    sideChartRed: '#D9534F',

    sideChartBlue: '#37A3EF'
}

export const channels = ['gamma', 'resistivity1', 'resistivity2']

export const channelsColors = {
    [channels[0]]: colors.sideChartGreen,
    [channels[1]]: colors.sideChartRed,
    [channels[2]]: colors.sideChartBlue
}

export default colors

export function getPathPointFromObj(obj: PointType, index: number): string {
    return `${index ? 'L' : 'M'}${obj.x}, ${obj.y}`
}

export function getPathFromArray(array: PointType[]): string {
    const p = path()
    array.forEach((element, index) => {
        const { x, y } = element
        index == 0 ? p.moveTo(x, y) : p.lineTo(x, y)
    })

    return p.toString()
}

/**
 * this func turns angles in radians to angles in degrees
 * @param radAngle the angle in radians
 */
export function radToDeg(radAngle): number {
    return radAngle * (180 / Math.PI) - 90
}

export function getTrajectoryFakePoints(numOfPoints) {
    let answerString = ''
    // let currentDepth = 0
    for (let index = 0; index < numOfPoints; index++) {
        const fakeObj = [
            {
                liverig__object: {
                    uid: '123456',
                    name: 'well-for-test',
                    object: 'trajectory'
                },
                uid: '7891011',
                azi: { uom: 'rad', value: 0 },
                dispEw: { uom: 'm', value: 0 },
                __type: 'wellWbsTest_objects',
                md: { uom: 'm', value: index },
                timestamp: index,
                tvd: { uom: 'm', value: index },
                dispNs: { uom: 'm', value: 0 },
                vertSect: { uom: 'm', value: 0 },
                incl: { uom: 'rad', value: 0 },
                __src: 'pipes',
                __skiprealtime: true
            }
        ]
        answerString = answerString + JSON.stringify(fakeObj)
    }

    return answerString
}

export const zoomOptions = {
    zoomEntireWell: 'zoomEntireWell',
    followBitDepth: 'followBitDepth',
    free: 'free'
} as const
const zoomOptionsArr = [...Object.values(zoomOptions)] as const

export type ZoomStatus = typeof zoomOptionsArr[number]